import { Box, Container, Grid } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Section from "./Section";
import SEO from "./SEO";

import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import * as React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

import AfterRepairImage from "../assets/after-repair.jpg";
import AfterRentImage from "../assets/after-rent.jpg";
import ForBusinessImage from "../assets/for-business.jpg";
import { ReactComponent as HourglassSvg } from "../assets/hourglass.svg";
import { ReactComponent as LogoSvg } from "../assets/logo.svg";
import { ReactComponent as SparkSvg } from "../assets/spark.svg";
import { ReactComponent as KeySvg } from "../assets/key.svg";
import { ReactComponent as LeafSvg } from "../assets/leaf-wind.svg";
import { ReactComponent as FeatherSvg } from "../assets/feather.svg";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import { MOBILE_NUMBER } from "../constants/contacts";
import { keyframes } from "@mui/system";
const ring = keyframes`
  0% { transform: rotate(0); }
  10% { transform: rotate(15deg); }
  20% { transform: rotate(-15deg); }
  30% { transform: rotate(10deg); }
  40% { transform: rotate(-10deg); }
  50% { transform: rotate(5deg); }
  60% { transform: rotate(-5deg); }
  70% { transform: rotate(0); }
  100% { transform: rotate(0); }
`;

const Phone = (
  <Box>
    <a href={`tel:${MOBILE_NUMBER}`}>
      <Button
        sx={{
          xs: "inline-flex",
          md: "none",
          mt: 2,
          background: "white",
          borderRadius: "10px",
          border: "2px solid #f5c33d",
          width: "50px",
          height: "50px",
          boxShadow: "0 0 5px #FFD700, 0 0 10px #ffd181, 0 0 15px #f7bb5c",
        }}
      >
        <LocalPhoneIcon
          sx={{
            color: "#f5c33d",
            animation: `${ring} 1.5s ease-in-out infinite`,
            m: 0,
            width: "1.5em",
            height: "1.5em",
          }}
        />
      </Button>
    </a>
  </Box>
);
function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ textAlign: "left" }}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const TAB_MAP = {
  "after-repair": 0,
  "after-rent": 1,
  "for-business": 2,
};

const TAB_REVERSE_MAP = {
  0: "after-repair",
  1: "after-rent",
  2: "for-business",
};

const SEO_DATA = {
  "after-repair": {
    title: "Прибирання після ремонту в Ужгороді | Sweet Clean",
    description:
      "Професійне прибирання після ремонту в Ужгороді. Видаляємо будівельний пил, очищаємо всі поверхні та готуємо приміщення до комфортного використання.",
  },

  "after-rent": {
    title: "Післяорендне прибирання в Ужгороді | Sweet Clean",
    description:
      "Післяорендне прибирання квартир та будинків в Ужгороді. Повернемо оселі чистоту та свіжість перед новими мешканцями.",
  },

  "for-business": {
    title: "Клінінг для бізнесу в Ужгороді | Sweet Clean",
    description:
      "Професійний клінінг офісів, магазинів та комерційних приміщень в Ужгороді. Індивідуальний графік та стабільна якість.",
  },
};

export default function ServiceDetails() {
  const { tab } = useParams();
  const seo = SEO_DATA[tab] ?? SEO_DATA["after-repair"];
  const navigate = useNavigate();

  const [value, setValue] = React.useState(TAB_MAP[tab] ?? 0);

  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
  }, [pathname]);

  React.useEffect(() => {
    setValue(TAB_MAP[tab] ?? 0);
  }, [tab]);

  const handleChange = (_, newValue) => {
    setValue(newValue);

    navigate(`/serviceDetails/${TAB_REVERSE_MAP[newValue]}`);
  };

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        url={`https://sweet-clean.com.ua/serviceDetails/${tab}`}
      />
      <Section id="service-details">
        <Container
          sx={{
            minHeight: "calc(100vh - 200px)",
            pt: 2,
            pb: 2,
            overflow: "hidden",
          }}
        >
          <Toolbar />
          <Box
            sx={{
              width: "100%",
              bgcolor: "#fff",
              color: "#000",
              borderRadius: 2,
              p: 2,
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
            }}
          >
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
                aria-label="basic tabs example"
                centered
              >
                <Tab
                  label="Післяремонтне прибирання"
                  {...a11yProps(0)}
                  sx={{ width: "100%", fontWeight: 700, whiteSpace: "nowrap" }}
                />
                <Tab
                  label="Післяорендне прибирання"
                  {...a11yProps(1)}
                  sx={{ width: "100%", fontWeight: 700, whiteSpace: "nowrap" }}
                />
                <Tab
                  label="Для бізнесу"
                  {...a11yProps(2)}
                  sx={{ width: "100%", fontWeight: 700 }}
                />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Box sx={{ textAlign: "center" }}>
                {/* Фото */}
                <Box
                  component="img"
                  src={AfterRepairImage}
                  alt="Післяремонтне прибирання"
                  sx={{
                    width: "100%",
                    maxWidth: 700,
                    borderRadius: 2,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    mb: 4,
                  }}
                />

                {/* Економія часу */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "start",
                    mb: 2,
                  }}
                >
                  <HourglassSvg width={40} height={30} />
                  <Typography
                    variant="h5"
                    sx={{
                      color: "#f5c33d",
                      fontWeight: 700,
                    }}
                  >
                    Збереження часу
                    <br />
                    3–5 днів
                  </Typography>
                </Box>

                {/* Опис */}
                <Typography
                  sx={{
                    mx: "auto",
                    mb: 5,
                    fontSize: "1.1rem",
                    lineHeight: 1.8,
                    color: "#5f2e20",
                    textAlign: "justify",
                    textIndent: "30px",
                  }}
                >
                  Ремонт закінчився, а від пилу й сміття здається ніби будуть ще
                  три тури робіт.{" "}
                  <b>
                    Ми повертаємо житлу життя, а{" "}
                    <Typography
                      variant="span"
                      sx={{
                        color: "#f5c33d",
                        fontWeight: 700,
                      }}
                    >
                      Вам - спокій.
                    </Typography>
                  </b>
                </Typography>

                {/* Алгоритм */}
                <Typography
                  variant="h5"
                  sx={{
                    color: "#5f2e20",
                    fontWeight: 700,
                    mb: 3,
                  }}
                >
                  Алгоритм
                </Typography>

                {/* Рівень 1 */}
                <Box sx={{ mb: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <SparkSvg width={28} height={28} />
                    <Typography
                      variant="h5"
                      sx={{ color: "#f5c33d", fontWeight: 700 }}
                    >
                      Вищий рівень
                    </Typography>
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{ color: "#5f2e20", textAlign: "left" }}
                  >
                    Стеля, стіни
                  </Typography>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                    height: 2,
                    backgroundColor: "#f5c33d",
                    mb: 3,
                  }}
                />

                {/* Рівень 2 */}
                <Box sx={{ mb: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <KeySvg width={28} height={28} />
                    <Typography
                      variant="h5"
                      sx={{ color: "#f5c33d", fontWeight: 700 }}
                      className="golden-text"
                    >
                      Внутрішній рівень
                    </Typography>
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{ color: "#5f2e20", textAlign: "left" }}
                  >
                    Меблі, деталі
                  </Typography>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                    height: 2,
                    backgroundColor: "#f5c33d",
                    mb: 3,
                  }}
                />

                {/* Рівень 3 */}
                <Box sx={{ mb: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <LeafSvg width={28} height={28} />
                    <Typography
                      variant="h5"
                      sx={{ color: "#f5c33d", fontWeight: 700 }}
                      className="golden-text"
                    >
                      Базовий рівень
                    </Typography>
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{ color: "#5f2e20", textAlign: "left" }}
                  >
                    Підлога, покриття
                  </Typography>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                    height: 2,
                    backgroundColor: "#f5c33d",
                    mb: 3,
                  }}
                />

                {/* Опис */}
                <Box sx={{ mb: 3 }}>
                  <Box
                    sx={{
                      float: "left",
                      width: 1.5,
                      height: 1.5,
                      mr: 2.5,
                      mt: "2px",
                    }}
                  >
                    <SparkSvg
                      style={{
                        width: "18px",
                        height: "18px",
                        display: "block",
                      }}
                    />
                  </Box>

                  {/* Text flows naturally around icon */}
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      lineHeight: 1.8,
                      textAlign: "justify",
                      color: "#5f2e20",
                      textAlign: "justify",
                      display: "block",
                      textIndent: "30px",
                    }}
                    component="span"
                  >
                    Ми дбаємо про кожну деталь. Повний протокол робіт ми
                    погоджуємо індивідуально під Ваш простір.
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    lineHeight: 0,
                    mt: 10,
                    mb: 8,
                  }}
                >
                  <LogoSvg
                    style={{
                      width: "6rem",
                      height: "6rem",
                      display: "block",
                      transformOrigin: "center",
                      animation: "pulse 2s infinite",
                    }}
                  />
                </Box>
                {/* Ціна */}
                <Typography
                  variant="h5"
                  sx={{
                    color: "#f5c33d",
                    mt: 3,
                    mb: 1,
                  }}
                  className="golden-text"
                >
                  Ціна від <b>110</b> грн/м²
                </Typography>

                <Typography
                  sx={{
                    mx: "auto",
                    color: "#5f2e20",
                    fontSize: "0.9rem",
                    opacity: 0.5,
                    textAlign: "justify",
                    textIndent: "30px",
                  }}
                >
                  Фінальна вартість формується індивідуально після знайомства з
                  Вашим простором.
                </Typography>
                {Phone}
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Box sx={{ textAlign: "center" }}>
                {/* Фото */}
                <Box
                  component="img"
                  src={AfterRentImage}
                  alt="Післяорендне прибирання"
                  sx={{
                    width: "100%",
                    maxWidth: 700,
                    borderRadius: 2,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    mb: 4,
                  }}
                />

                {/* Економія часу */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "start",
                    mb: 2,
                  }}
                >
                  <HourglassSvg width={40} height={30} />
                  <Typography
                    variant="h5"
                    sx={{
                      color: "#f5c33d",
                      fontWeight: 700,
                    }}
                  >
                    Збереження часу
                    <br />
                    1–3 днів
                  </Typography>
                </Box>

                {/* Опис */}
                <Typography
                  sx={{
                    mx: "auto",
                    mb: 5,
                    fontSize: "1.1rem",
                    lineHeight: 1.8,
                    color: "#5f2e20",
                    textAlign: "justify",
                    textIndent: "30px",
                  }}
                >
                  Зайшли в квартиру, а там такий хаос, що хочеться зафіксувати
                  це для історії <b>"до та після"</b>. Ми перетворюємо Ваш{" "}
                  <b>шок на бездоганну чистоту</b>, щоб нові орендарі{" "}
                  <Typography
                    variant="span"
                    sx={{
                      color: "#f5c33d",
                      fontWeight: 700,
                    }}
                  >
                    закохалися в свій дім з першого погляду
                  </Typography>
                  .
                </Typography>

                <Typography
                  variant="h5"
                  sx={{
                    color: "#5f2e20",
                    fontWeight: 700,
                    mb: 3,
                  }}
                >
                  Відновлення здоров'я дому
                </Typography>

                <Typography
                  sx={{
                    mx: "auto",
                    fontSize: "1.1rem",
                    lineHeight: 1.8,
                    color: "#5f2e20",
                    textAlign: "justify",
                    textIndent: "30px",
                  }}
                >
                  Ми делікатно видаляємо історію попереднього перебування,
                  повертаючи дому його первісну свіжість та бездоганну безпеку.
                  <br />
                  <div
                    style={{
                      fontWeight: "bold",
                      fontStyle: "italic",
                      color: "#f5c33d",
                      textIndent: "30px",
                    }}
                  >
                    Це Ваш чистий аркуш.
                    <FeatherSvg
                      style={{
                        marginLeft: "5px",
                        width: "15px",
                        height: "15px",
                        opacity: 0.6,
                        pointerEvents: "none",
                      }}
                    />
                  </div>
                </Typography>

                <Typography
                  sx={{
                    mx: "auto",
                    mb: 5,
                    fontSize: "1.1rem",
                    lineHeight: 1.8,
                    color: "#5f2e20",
                    textAlign: "justify",
                    textIndent: "30px",
                  }}
                >
                  Ви дбаєте про те, щоб нові мешканці відчули затишок з першої
                  миті. Ми створюємо цей стан, адаптуючи кожен крок під Ваші
                  індивідуальні вимоги та стандарти безпеки.
                </Typography>
                {/* Алгоритм */}
                {/* Рівень 1 */}
                <Box sx={{ mb: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <SparkSvg width={28} height={28} />
                    <Typography
                      variant="h5"
                      sx={{ color: "#f5c33d", fontWeight: 700 }}
                    >
                      Вищий рівень
                    </Typography>
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{ color: "#5f2e20", textAlign: "left" }}
                  >
                    Повітря та об'єм
                  </Typography>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                    height: 2,
                    backgroundColor: "#f5c33d",
                    mx: "auto",
                    mb: 3,
                  }}
                />

                {/* Рівень 2 */}
                <Box sx={{ mb: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <KeySvg width={28} height={28} />
                    <Typography
                      variant="h5"
                      sx={{ color: "#f5c33d", fontWeight: 700 }}
                    >
                      Внутрішній рівень
                    </Typography>
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{ color: "#5f2e20", textAlign: "left" }}
                  >
                    Гігієна та деталі
                  </Typography>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                    height: 2,
                    backgroundColor: "#f5c33d",
                    mx: "auto",
                    mb: 3,
                  }}
                />

                {/* Рівень 3 */}
                <Box sx={{ mb: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "start",
                      alignItems: "center",
                      gap: 1,
                      mb: 1,
                    }}
                  >
                    <LeafSvg width={28} height={28} />
                    <Typography
                      variant="h5"
                      sx={{ color: "#f5c33d", fontWeight: 700 }}
                    >
                      Базовий рівень
                    </Typography>
                  </Box>

                  <Typography
                    variant="h6"
                    sx={{ color: "#5f2e20", textAlign: "left" }}
                  >
                    Основа та безпека
                  </Typography>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                    height: 2,
                    backgroundColor: "#f5c33d",
                    mx: "auto",
                    mb: 3,
                  }}
                />
                {/* Опис */}
                <Box sx={{ mb: 3 }}>
                  <Box
                    sx={{
                      float: "left",
                      width: 1.5,
                      height: 1.5,
                      mr: 2.5,
                      mt: "2px",
                    }}
                  >
                    <SparkSvg
                      style={{
                        width: "18px",
                        height: "18px",
                        display: "block",
                      }}
                    />
                  </Box>

                  {/* Text flows naturally around icon */}
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      lineHeight: 1.8,
                      textAlign: "justify",
                      color: "#5f2e20",
                      textAlign: "justify",
                      display: "block",
                      textIndent: "30px",
                    }}
                    component="span"
                  >
                    Повний протокол робіт ми погоджуємо індивідуально під Ваші
                    вимоги та сценарій безпеки.
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    lineHeight: 0,
                    mt: 10,
                    mb: 8,
                  }}
                >
                  <LogoSvg
                    style={{
                      width: "6rem",
                      height: "6rem",
                      display: "block",
                      transformOrigin: "center",
                      animation: "pulse 2s infinite",
                    }}
                  />
                </Box>
                {/* Ціна */}
                <Typography
                  variant="h5"
                  sx={{
                    color: "#f5c33d",
                    mt: 3,
                    mb: 1,
                  }}
                >
                  Ціна від <b>70</b> грн/м²
                </Typography>

                <Typography
                  sx={{
                    maxWidth: 700,
                    mx: "auto",
                    color: "#5f2e20",
                    fontSize: "0.9rem",
                    opacity: 0.5,
                    textAlign: "justify",
                    textIndent: "30px",
                  }}
                >
                  Кінцева вартість формується індивідуально після знайомства з
                  Вашим простором.
                </Typography>
                {Phone}
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <Box sx={{ textAlign: "center" }}>
                {/* Фото */}
                <Box
                  component="img"
                  src={ForBusinessImage}
                  alt="Для бізнесу"
                  sx={{
                    width: "100%",
                    maxWidth: 700,
                    borderRadius: 2,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    mb: 4,
                  }}
                />

                {/* Опис */}
                <Typography
                  sx={{
                    mx: "auto",
                    mb: 5,
                    fontSize: "1.1rem",
                    lineHeight: 1.8,
                    color: "#5f2e20",
                    textAlign: "justify",
                    textIndent: "30px",
                  }}
                >
                  Ми будуємо сервіс навколо Ваших задач. Кожна пропозиція для
                  бізнесу та ОСББ розглядається в{" "}
                  <Typography
                    sx={{
                      color: "#f5c33d",
                      fontSize: "1.1rem",
                      lineHeight: 1.8,
                      fontWeight: "bold",
                    }}
                    variant="span"
                  >
                    індивідуальному порядку,
                  </Typography>{" "}
                  а вартість розраховується{" "}
                  <Typography
                    sx={{
                      color: "#f5c33d",
                      fontSize: "1.1rem",
                      lineHeight: 1.8,
                      fontWeight: "bold",
                    }}
                    variant="span"
                  >
                    персонально
                  </Typography>{" "}
                  та під Ваш об'єкт.
                </Typography>

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    lineHeight: 0,
                    mt: 10,
                    mb: 8,
                  }}
                >
                  <LogoSvg
                    style={{
                      width: "6rem",
                      height: "6rem",
                      display: "block",
                      transformOrigin: "center",
                      animation: "pulse 2s infinite",
                    }}
                  />
                </Box>
                {Phone}
              </Box>
            </CustomTabPanel>
          </Box>
        </Container>
      </Section>
    </>
  );
}
